export default ({vehicle: {vehicle_model = ''} = {}} = {}) => vehicle_model;
